// This file is AUTOGENERATED, do not edit it manually!!!

export const users = {
    active: 'Активный',
    active_switch_description: 'Отключение свойства \"Активный\" у пользователя приводит к двум вещам: высвобождается лицензия для другого пользователя и неактивный пользователь становится невидимым всюду в системе, кроме страницы \"Пользователи\".',
    add_user: 'Добавить пользователя',
    apply: 'Применить',
    assign: 'Включить',
    assigned_activities_menu_title: 'Назначенные активности',
    can_login: 'Вход в систему',
    can_login_switch_description: 'Отключая \"Вход в систему\", вы лишь отнимаете у пользователя право на вход в систему. Он по-прежнему может быть членом проекта или назначенным на задачу. При этом также высвобождается лицензия.',
    cancel: 'Отмена',
    CanDenyLogin_User_DenyLoginYourself: 'Нельзя отключить право входа у самого себя.',
    CanDenyLogin_User_LastAdministrator: 'Нельзя отключить право входа у единственного администратора в системе.',
    CanDisable_User_DisableYourself: 'Нельзя отключить свойство \"Активный\" у самого себя.',
    CanDisable_User_LastAdministrator: 'Нельзя отключить свойство \"Активный\" у пользователя, являющегося единственным администратором в системе.',
    cant_delete_user: 'Пользователь \"{0}\" не может быть удалён',
    cant_login: 'Без права входа',
    change_password: 'Изменить пароль',
    close: 'Закрыть',
    convert_title: 'Конвертировать',
    convert_to_regular: 'Конвертировать в пользователя',
    convert_to_regular_title: 'Конвертировать {0} в пользователя с ролью:',
    convert_to_regular_title_with_job_role: 'Конвертировать {0} в пользователя с должностью:',
    deactivate: 'Сделать неактивным',
    deactivateTitle: 'Изменение статуса пользователя на \"Неактивный\"',
    delete: 'Удалить',
    delete_confirm: 'Удалить пользователя \"{0}\"?',
    delete_skill_title: 'Удалить навык',
    delete_team_title: 'Удалить команду',
    DeleteRateBtnTitle: 'Удалить навсегда',
    Disable_Permission_Message: 'Вы собираетесь отключить право в вашей роли, позволяющее редактировать собственные права и права других пользователей.',
    Disable_Permission_Title: 'Редактирование прав пользователей станет вам недоступно.',
    DisplayName_customerId: 'Заказчик',
    DisplayName_hourlyRate: 'Тарифная почасовая ставка',
    DisplayName_hourlyRateInternal: 'Внутренняя почасовая ставка',
    DisplayName_login: 'Имя пользователя',
    email: 'Адрес эл. почты',
    exclude: 'Исключить',
    filterbystatus_Active: 'Только активные',
    filterbystatus_All: 'Активные и неактивные',
    filterbystatus_CannotLogin: 'Только без права входа',
    filterbystatus_Inactive: 'Только неактивные',
    generate: 'Сгенерировать',
    guest_portal_title: 'Гостевой Портал.',
    guest_users_personal_scheduled_description: 'Личный график не используется для гостевых пользователей. Однако он будет применяться при расчете доступности и нагрузки после преобразования этого пользователя в обычного.',
    guests_interaction: 'Гости могут взаимодействовать с системой только через',
    guests_license: 'Для них не нужна лицензия.',
    guests_users_tab_title: 'Гости',
    import_title: 'Импорт',
    inactive: 'Неактивный',
    jobroles_updated_successfully: 'Должности были успешно изменены',
    lastActivityDate_title: 'Последний визит',
    licensing_limits_warning: 'Вы не можете дать право входа в систему данному пользователю, потому что Ваша лицензия не позволяет добавлять больше пользователей с правом входа.',
    name_column_title: 'Имя',
    no_sercurity_logs: 'У пользователя пока нет записей',
    password_changed: 'Пароль был изменен.',
    personal_schedule_title: 'Личный график',
    regular_users_tab_title: 'Обычные',
    reload: 'Обновить',
    remove_confirm: 'Удалить пользователя?',
    reset: 'Применить',
    reset_password_confirmation: 'По нажатию «Сгенерировать» будет сгенерирован новый пароль и отослан пользователю.',
    reset_password_done: 'Новый пароль сгенерирован и отправлен.',
    reset_password_menu_title: 'Сгенерировать и отправить пароль',
    reset_password_title: 'Вы действительно желаете сгенерировать и отправить по почте новый пароль?',
    reset_permissions_confirmation: 'После назначения пользователь будет иметь текущую роль во всех проектах, участником которых является этот пользователь. Операцию невозможно отменить.',
    reset_permissions_done: 'Текущая роль применена',
    reset_permissions_menu: 'Применить текущую роль',
    reset_permissions_title: 'Вы действительно желаете применить текущую роль ко всем проектам пользователя?',
    security_logs_action: 'Действие',
    security_logs_date: 'Дата',
    security_logs_modal_title: 'Журнал безопасности для',
    security_logs_title: 'Журнал безопасности',
    securitylog_msg_GuestConverted: 'Роль была изменена с гостевой на {0} пользователем {1}.',
    securitylog_msg_LoginChanged: 'Логин был изменен пользователем {0}.',
    securitylog_msg_LoginChangedBySelf: 'Логин был изменен.',
    securitylog_msg_PasswordChanged: 'Пароль был изменен пользователем {0}.',
    securitylog_msg_PasswordChangedByRecovery: 'Пароль был восстановлен.',
    securitylog_msg_PasswordChangedBySelf: 'Пароль был изменен.',
    securitylog_msg_PasswordGenerated: 'Пароль был сгенерирован пользователем {0}.',
    securitylog_msg_PasswordGeneratedBySelf: 'Пароль был сгенерирован.',
    securitylog_msg_PasswordIncorrect: 'Неверный пароль.',
    securitylog_msg_RecoveryRequest: 'Запрос на восстановление.',
    securitylog_msg_RoleChanged: 'Роль была изменена с {0} на {1} пользователем {2}.',
    securitylog_msg_UserLockout: 'Пользователь был заблокирован после нескольких неудачных попыток ввести пароль.',
    securitylog_msg_UserLockoutDueToInactivity: 'Пользователь заблокирован из-за неактивности.',
    securitylog_msg_UserUnlocked: 'Пользователь был разблокирован пользователем {0}.',
    selected_users: '7#Выбран {0} пользователь #Выбрано {0} пользователя#Выбрано {0} пользователей',
    Set_skills: 'Добавить навыки',
    Set_teams: 'Команды',
    show: 'Показаны',
    show_other_reasons: 'Показать другие причины',
    skills: 'Навыки',
    skills_updated_successfully: 'Навыки были успешно изменены',
    skillsDeleteConfirm: 'Данный навык будет удалён со всех профилей пользователей, где он используется',
    spaces: 'Рабочие пространства',
    suggest_deactivate: 'Однако у вас есть возможность сделать пользователя неактивным, что приведет к удалению его видимости в {brandName}, за исключением страницы «Пользователи» и истории назначения проектов и задач. Это действие освободит лицензию для другого пользователя.',
    teams: 'Команды',
    teams_updated_successfully: 'Команды были успешно изменены',
    teamsDeleteConfirm: 'Данная команда будет удалена у всех пользователей',
    TimerText: '7#{0} секунда#{0} секунды#{0} секунд',
    unlock: 'Разблокировать',
    user_conversion_done: '{0} сконвертирован.',
    user_conversion_title: 'Конвертация пользователей',
    user_duplicate_email_error: 'Пользователь с указанным email-адресом уже существует',
    user_duplicate_login_error: 'Пользователь с указанным логином уже существует',
    user_licensing_limits_warning: 'Нельзя включить право входа для данного пользователя, т.к. достигнуто максимальное количество пользователей с правом входа в лицензии.',
    User_NotFound_Title: 'Пользователь не найден',
    userRates: 'Журнал ставок',
    userRates_changed_by: 'Изменено',
    userRates_date: 'Дата изменения',
    userRates_hourlyRate: 'Тарифная почасовая ставка',
    userRates_hourlyRateInternal: 'Внутренняя почасовая ставка',
    userRates_title: 'Журнал ставок для {0}',
};
